module.exports = checkListItemIndent;
function checkListItemIndent(context) {
  var style = context.options.listItemIndent || 'tab';
  if (style === 1 || style === '1') {
    return 'one';
  }
  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
  }
  return style;
}